var _a, _b, _c;
import Color from "color";
import { createBreakpoints, createColors } from "../theme";
import { BackgroundType } from "../components/Background";
import { sasBrandColor } from "./brandColors";
var leaderboardColors = {
    yellow: "#FFCC33",
    deepYellow: "#D9A30B",
    lightYellow: "#FFE86F"
};
var TeamInfos = {
    first: {
        name: "yellow",
        main: "#D9A30B",
        lightBG: "#FFDF73",
        mediumBG: "#FFCC33",
        darkBG: "#FFDF73", // Background for Leaderboard Row
    },
    second: {
        name: "red",
        main: "#CC2D2D",
        lightBG: "#FF9999",
        mediumBG: "#F24949",
        darkBG: "#FF9999",
    },
    third: {
        name: "teal",
        main: "#06C1CC",
        lightBG: "#79E8F2",
        mediumBG: "#3ADBE6",
        darkBG: "#79E8F2",
    },
    fourth: {
        name: "green",
        main: "#29B869",
        lightBG: "#79F2AF",
        mediumBG: "#36D982",
        darkBG: "#79F2AF",
    }
};
export var brand2023 = {
    host: {
        create: {
            errorColor: "#F44336",
        },
        game: {
            pauseColor: "#F44336",
        },
    },
    welcome: {
        welcomeText: { color: sasBrandColor.lightBlue },
        subtitle: {
            color: sasBrandColor.lightBlue
        },
        instructions: {
            instructionBorder: "1px solid ".concat(sasBrandColor.lightBlue),
            small: {
                src: "/assets/instructions/brand2023/instructions-small.jpeg",
                countdown: {
                    label: {
                        top: -1,
                        left: 117,
                    },
                    text: {
                        top: 5,
                        left: 10
                    }
                },
                submit: {
                    label: {
                        top: 118,
                        left: 98
                    },
                    text: {
                        top: 131,
                        left: 10
                    }
                }
            },
            other: {
                countdown: {
                    label: {
                        top: 14,
                        left: 401,
                    },
                    text: {
                        top: 31,
                        left: 0,
                    }
                },
                submit: {
                    label: {
                        top: 224,
                        left: 243
                    },
                    text: {
                        top: 249,
                    }
                }
            },
            large: {
                src: "/assets/instructions/brand2023/instructions-large.jpeg",
                countdown: {
                    label: {
                        top: 14,
                        left: 229
                    },
                    text: {
                        top: 6,
                        left: 0,
                    }
                },
                submit: {
                    label: {
                        top: 124,
                        left: 135
                    },
                    text: {
                        top: 128,
                    }
                }
            },
        },
        actionButton: {
            border: "none",
            textTransform: "none",
            color: sasBrandColor.white,
        },
    },
    background: {
        backgroundImage: {
            large: (_a = {},
                _a[BackgroundType.Welcome] = "url('/assets/backgrounds/brand2023/bg-large-welcome.svg')",
                _a[BackgroundType.GetStarted] = "url('/assets/backgrounds/brand2023/bg-large-welcome.svg')",
                _a[BackgroundType.Main] = "none",
                _a[BackgroundType.ThankYou] = "url('/assets/backgrounds/brand2023/bg-large-thankyou.svg')",
                _a),
            small: (_b = {},
                _b[BackgroundType.Welcome] = "url('/assets/backgrounds/brand2023/bg-small-welcome.svg')",
                _b[BackgroundType.GetStarted] = "url('/assets/backgrounds/brand2023/bg-small-welcome.svg')",
                _b[BackgroundType.Main] = "none",
                _b[BackgroundType.ThankYou] = "url('/assets/backgrounds/brand2023/bg-small-thankyou.svg')",
                _b),
        },
        backgroundColor: (_c = {},
            _c[BackgroundType.Welcome] = sasBrandColor.sasBlue,
            _c[BackgroundType.GetStarted] = sasBrandColor.sasBlue,
            _c[BackgroundType.Main] = sasBrandColor.sasBlue,
            _c[BackgroundType.ThankYou] = sasBrandColor.sasBlue,
            _c)
    },
    gameComplete: {
        //Future theming note: with future themes, may need to consider fully theming decorative circles
        decorativeCircles: false,
        thankYouTextColor: "white",
        background: sasBrandColor.sasBlue
    },
    presenterVideo: {
        background: sasBrandColor.midnightBlue,
        muteBackground: sasBrandColor.lightBlue,
        textBackground: sasBrandColor.lightBlue,
    },
    questionPrompt: {
        background: sasBrandColor.midnightBlue,
        timerColor: sasBrandColor.white,
        timeRemainderColor: leaderboardColors.yellow
    },
    questionExplanation: {
        //Using RGB to get opacity right
        backgroundColor: "rgb(0, 60, 147, 0.5)"
    },
    multipleChoice: {
        multipleChoiceColors: {
            first: sasBrandColor.midnightBlue,
            second: "#003C93",
            third: "#0051b7",
            fourth: "#3689E3",
            disabled: "#A2A2A2"
        },
        feedbackColor: "#99EFEF"
    },
    phrase: {
        foregroundColor: "lightgray",
        foregroundFocusColor: "darkgray"
    },
    questionSubmit: {
        border: "2px solid white",
        borderRadius: 24,
        background: sasBrandColor.midnightBlue,
        icon: {
            color: sasBrandColor.white,
            backgroundColor: "none"
        },
        foreground: sasBrandColor.white
    },
    questionProgress: {
        pastBox: {
            backgroundColor: sasBrandColor.midnightBlue,
        },
        currentBox: {
            backgroundColor: leaderboardColors.yellow,
        }
    },
    chat: {
        inputBorder: "1px solid darkgray",
        scrollBar: sasBrandColor.lightBlue,
        background: {
            focused: sasBrandColor.midnightBlue,
            unfocused: sasBrandColor.midnightBlue
        },
        colorDark: "#2398F9",
        colorLight: sasBrandColor.lightBlue,
        nicknameFontWeight: 700,
        sendButton: {
            background: sasBrandColor.sasBlue
        }
    },
    teamInfos: TeamInfos,
    accessoryPanel: {
        background: "transparent linear-gradient(180deg, #0046A6 0%, #005BC5 100%) 0% 0% no-repeat padding-box",
        expandButton: {
            background: "#0046A6",
            desktop: {
                chevron: {
                    src: "/assets/accessory/common/expand-desktop.png",
                    srcSet: "/assets/accessory/common/expand-desktop.png, /assets/accessory/common/expand-desktop@2x.png 2x"
                },
                chevronWarning: {
                    src: "/assets/accessory/brand2023/expand-desktop-glow.png",
                    srcSet: "/assets/accessory/brand2023/expand-desktop-glow.png, /assets/accessory/brand2023/expand-desktop-glow@2x.png 2x"
                }
            },
            mobile: {
                expand: {
                    src: "/assets/accessory/brand2023/expand-mobile.png",
                    srcSet: "/assets/accessory/brand2023/expand-mobile.png, /assets/accessory/brand2023/expand-mobile@2x.png 2x"
                },
                expandGlow: {
                    src: "/assets/accessory/brand2023/expand-mobile-glow.png",
                    srcSet: "/assets/accessory/brand2023/expand-mobile-glow.png, /assets/accessory/brand2023/expand-mobile-glow@2x.png 2x"
                }
            }
        },
        tabs: {
            background: sasBrandColor.midnightBlue,
            leaderboardIcon: "/assets/icons/brand2023/leaderboard.svg",
            chatIcon: "/assets/icons/brand2023/chat.svg",
            dashboardIcon: "/assets/icons/brand2023/dashboard.svg",
            tabSelector: "1px solid ".concat(sasBrandColor.mediumBlue)
        },
        participantCounter: "circle",
        leaderboard: {
            teamAverage: {
                color: sasBrandColor.midnightBlue
            },
            rankChange: {
                down: "#ff6969",
                up: "#6af022"
            },
            row: {
                borderWidth: 0,
                rankedStreakSVG: "/assets/leaderboard/common/hot-streak-top-three.svg",
                unrankedStreakSVG: "/assets/leaderboard/common/hot-streak.svg",
                regularPlayer: {
                    rankedColor: sasBrandColor.midnightBlue,
                    unrankedColor: sasBrandColor.white,
                    team: {
                        rankedColor: sasBrandColor.midnightBlue,
                        unrankedColor: sasBrandColor.midnightBlue,
                    },
                },
                currentPlayer: {
                    borderWidth: "2px 0 2px 2px",
                    borderColor: "#E2EEFF",
                    unrankedColor: sasBrandColor.white,
                    rankedColor: sasBrandColor.midnightBlue,
                    rankChangeUnrankedColor: sasBrandColor.white,
                    rankChangeRankedColor: sasBrandColor.midnightBlue,
                    team: {
                        unrankedColor: sasBrandColor.midnightBlue,
                        rankedColor: sasBrandColor.midnightBlue,
                        rankChangeUnrankedColor: sasBrandColor.midnightBlue,
                        borderColor: "#E2EEFF",
                        rankChangeRankedColor: sasBrandColor.midnightBlue,
                    },
                },
            },
            scorePill: {
                showBorder: false
            },
            rank: {
                showBorder: false
            },
            firstPlace: {
                backgroundColor: leaderboardColors.deepYellow,
                highlightColor: sasBrandColor.midnightBlue,
                borderColor: "none"
            },
            secondPlace: {
                backgroundColor: leaderboardColors.yellow,
                highlightColor: sasBrandColor.midnightBlue,
                borderColor: "none"
            },
            thirdPlace: {
                backgroundColor: leaderboardColors.lightYellow,
                highlightColor: sasBrandColor.midnightBlue,
                borderColor: "none"
            },
            default: {
                borderColor: "none",
                backgroundColor: Color(sasBrandColor.midnightBlue).alpha(0.4).rgb().string(),
            }
        },
        dashBoard: {
            sectionTitleColor: "white",
            background: sasBrandColor.sasBlue,
            lineChart: {
                background: Color(sasBrandColor.midnightBlue).alpha(0.8).rgb().string(),
                svgBackground: "transparent linear-gradient(179deg, ".concat(sasBrandColor.midnightBlue, " 0%, ").concat(sasBrandColor.midnightBlue, " 100%) 0% 0% no-repeat padding-box"),
                currentPlayer: {
                    color: sasBrandColor.mediumBlue
                },
                hoverPlayer: {
                    color: sasBrandColor.lightBlue
                }
            },
            maxCorrect: {
                background: sasBrandColor.midnightBlue,
                highlightColor: "#FFCC33"
            },
            gauge: {
                background: Color(sasBrandColor.midnightBlue).alpha(0.9).rgb().string(),
                gaugeSVGPath: "/assets/dashboard/brand2023/gauge.svg",
                needleSVGPath: "/assets/dashboard/brand2023/needle.svg"
            },
            streak: {
                fireSVGPath: "/assets/dashboard/brand2023/streak.svg",
                streakNumberColor: Color(sasBrandColor.midnightBlue).alpha(0.9).rgb().string()
            },
            questionSummary: {
                background: Color(sasBrandColor.midnightBlue).alpha(0.9).rgb().string(),
                correct: {
                    answeredTextColor: sasBrandColor.midnightBlue,
                    backgroundColor: "#61A8FA"
                },
                incorrect: {
                    answeredTextColor: sasBrandColor.midnightBlue,
                    backgroundColor: "#CBCDD1"
                }
            },
            averageTime: {
                stopWatchSVGPath: "/assets/dashboard/brand2023/stopwatch.svg",
                host: {
                    timeColor: sasBrandColor.white,
                    background: Color(sasBrandColor.midnightBlue).alpha(0.8).rgb().string(),
                },
                player: {
                    timeColor: sasBrandColor.white,
                    background: Color(sasBrandColor.midnightBlue).alpha(0.8).rgb().string()
                }
            }
        },
    },
    breakpoints: createBreakpoints({
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1367,
            xxl: 2000,
            xxxl: 3000,
        }
    }),
    color: createColors(sasBrandColor.sasBlue, sasBrandColor.midnightBlue, "#E4E9EC", leaderboardColors.yellow),
};
//# sourceMappingURL=brand2023.js.map